import {
    GITCARD_LOADING, GET_GITCARD_DATA_SUCCESS,
    RESET_GITCARD, GET_GITCARD_DATA_ERROR, UPATE_GITCARD_DATA, UPDATE_GIFTCARD_QUANTITY,
    UPDATE_GIFTCARD_CUSTOMAMOUNT, REMOVE_GIFTCARD, ADDTOCART_GIFTCARD
} from "../actions/actionGiftCards";

import { loadState, saveState } from "../helpers/sessionStorage";

const sessionKey = "GiftCard";

const initialState = {
    giftcards: loadState(sessionKey, []),
    loading: false,
    giftcardsError: ''
};

function reducerGiftCards(state = initialState, action) {
    switch (action.type) {
        case GITCARD_LOADING: {
            return {
                ...state,
                loading: true,
                giftcardsError: ''
            };
        }

        case GET_GITCARD_DATA_SUCCESS: {

            let previousGiftCards = [...state.giftcards];

            let newGiftCards = action.payload;

            //if (previousGiftCards.length === 0 || (action.payload.length > 0 && previousGiftCards.length > 0 && action.payload[0].DisplayArea !== previousGiftCards[0].DisplayArea)) {

            newGiftCards = newGiftCards.map(m => {
                m.Qty = 0;
                m.CartQty = 0;
                m.TotalAmount = 0;
                m.CartTotalAmount = 0;
                m.AddedToCart = false;

                if (m.hasOwnProperty('MaxPrice')) {
                    m.CustomAmount = 0;
                    m.InvalidAmount = false;
                }

                if (previousGiftCards && previousGiftCards.length > 0) {
                    previousGiftCards.push(m);
                }

                return m;
            })

            if (previousGiftCards && previousGiftCards.length > 0) {
                saveState(sessionKey, previousGiftCards);
            }
            else {
                saveState(sessionKey, newGiftCards);
            }

            return {
                ...state,
                loading: false,
                giftcards: previousGiftCards && previousGiftCards.length > 0 ? previousGiftCards : newGiftCards,
                giftcardsError: ''
            };
        }

        case UPATE_GITCARD_DATA: {

            let newGiftCards = [...state.giftcards];
            let prevQty = 0;

            newGiftCards = newGiftCards.map(m => {

                if (m.ProductImageURL === action.payload.key) {

                    if (m.Qty > 0) {
                        prevQty = m.Qty;
                    }

                    if (m.Price === action.payload.price) {
                        m.isSelected = true;
                        m.Qty = prevQty;

                        m.TotalAmount = m.Price * m.Qty;
                    }
                    else {
                        m.Qty = 0;
                        m.TotalAmount = 0;
                        m.isSelected = false;
                    }
                }

                return m;
            })

            saveState(sessionKey, newGiftCards);

            return {
                ...state, giftcards: newGiftCards
            }
        }

        case UPDATE_GIFTCARD_QUANTITY: {

            let newGiftCards = [...state.giftcards];

            newGiftCards = newGiftCards.map(m => {

                if (m.ProductID === action.payload.ProductID) {
                    m.Qty = action.payload.Quantity;
                    m.TotalAmount = m.Price * m.Qty;

                    if (m.AddedToCart && action.payload.IsCheckOut) {
                        m.CartQty = action.payload.Quantity;
                        m.CartTotalAmount = m.Price * m.CartQty;

                        m.Qty = m.TotalAmount = 0;
                    }
                }

                return m;
            })

            saveState(sessionKey, newGiftCards);

            return {
                ...state, giftcards: newGiftCards
            }

        }

        case UPDATE_GIFTCARD_CUSTOMAMOUNT: {

            let newGiftCards = [...state.giftcards];

            newGiftCards = newGiftCards.map(m => {

                if (m.ProductID === action.payload.ProductID) {
                    m.TotalAmount = action.payload.Value;
                    m.CartTotalAmount = action.payload.Value;
                    m.Qty = 1;
                    m.CartQty = 1;
                    m.InvalidAmount = false;

                    if ((action.payload.Value > m.MaxPrice) || (action.payload.Value < m.Price)) {
                        m.InvalidAmount = true;
                    }

                    if (m.AddedToCart && action.payload.IsCheckOut) {
                        m.CartTotalAmount = action.payload.Value;
                        m.Qty = m.TotalAmount = 0;
                    }
                }

                return m;
            })

            saveState(sessionKey, newGiftCards);

            return {
                ...state, giftcards: newGiftCards
            }
        }
        case ADDTOCART_GIFTCARD: {

            let newGiftCards = [...state.giftcards];

            newGiftCards = newGiftCards.map(m => {

                if (m.DisplayArea === action.payload.DisplayArea) {

                    if (!m.hasOwnProperty('MaxPrice')) {

                        m.AddedToCart = true;
                        m.CartQty += m.Qty;
                        m.CartTotalAmount = m.Price * m.CartQty;

                        m.Qty = m.TotalAmount = 0;
                    }
                    else if (m.hasOwnProperty('MaxPrice')) {
                        m.AddedToCart = true;
                        m.Qty = m.TotalAmount = 0;
                    }
                }

                return m;
            })

            saveState(sessionKey, newGiftCards);

            return {
                ...state, giftcards: newGiftCards
            }
        }

        case REMOVE_GIFTCARD: {

            let newGiftCards = [...state.giftcards];

            newGiftCards = newGiftCards.map(m => {

                if (m.ProductID === action.payload.ProductID) {
                    m.TotalAmount = 0;
                    m.CartTotalAmount = 0;
                    m.Qty = 0;
                    m.CartQty = 0;
                    m.AddedToCart = false;
                }

                return m;
            })

            if (newGiftCards && newGiftCards.filter(x => x.CartQty > 0).length < 1) {
                newGiftCards = newGiftCards.map(m => {

                    m.AddedToCart = false;
                    return m;
                })
            }

            saveState(sessionKey, newGiftCards);

            return {
                ...state, giftcards: newGiftCards
            }

        }

        case GET_GITCARD_DATA_ERROR: {
            return {
                ...state,
                loading: false,
                giftcards: action.payload,
                giftcardsError: action.error
            }
        }
        case RESET_GITCARD: {

            saveState(sessionKey, []);

            return {
                ...state,
                loading: false,
                giftcards: [],
                giftcardsError: ''
            }
        }
        default: {
            return state;
        }
    }
}

export default reducerGiftCards;